import { render, staticRenderFns } from "./RelatedFormsCustomGridItem.vue?vue&type=template&id=dd54a93e"
import script from "./RelatedFormsCustomGridItem.vue?vue&type=script&lang=js"
export * from "./RelatedFormsCustomGridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports